module.exports = __webpack_public_path__ + "static/car-loan-desktop-bg-bc0cbd5367bd4536d0be7ef09f953854.jpg";